import Vue from 'vue'
import LAdmin from '../ladmin'
import store from '../store'
import router from '../router'

Vue.use(LAdmin, {
  router,
  store,
  isLogin () {
    return true
  },
  getPermission () {
    return {}
  },
  HOME_PAGE_NAME: 'Home',
  LOGIN_PAGE_NAME: 'Login',
  ACCESS_DENY_PAGE_NAME: 'AccessDeny',
  NOT_FOUND_PAGE_NAME: 'NotFound',
  MAIN_COMPONENT_NAME: 'Main'
})
